(function () {
  'use strict';

  // ─── Holiday Engine ───────────────────────────────────────────────────────

  function getUSHolidays(year) {
    var h = [];
    h.push(ymd(year, 1, 1));
    var mem = new Date(year, 4, 31);
    while (mem.getDay() !== 1) mem.setDate(mem.getDate() - 1);
    h.push(toYMD(mem));
    h.push(ymd(year, 7, 4));
    var lab = new Date(year, 8, 1);
    while (lab.getDay() !== 1) lab.setDate(lab.getDate() + 1);
    h.push(toYMD(lab));
    var thx = new Date(year, 10, 1);
    var thuCount = 0;
    while (thuCount < 4) {
      if (thx.getDay() === 4) thuCount++;
      if (thuCount < 4) thx.setDate(thx.getDate() + 1);
    }
    h.push(toYMD(thx));
    h.push(ymd(year, 12, 25));
    return h;
  }

  function ymd(year, month, day) {
    return year + '-' + pad(month) + '-' + pad(day);
  }

  function toYMD(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function isHoliday(date) {
    return getUSHolidays(date.getFullYear()).indexOf(toYMD(date)) !== -1;
  }

  // ─── Date Helpers ─────────────────────────────────────────────────────────

  function addDays(date, n) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + n);
    return d;
  }

  function toNextBusinessDay(date) {
    var d = new Date(date.getTime());
    while (d.getDay() === 0 || d.getDay() === 6 || isHoliday(d)) {
      d = addDays(d, 1);
    }
    return d;
  }

  // ─── Formatting ───────────────────────────────────────────────────────────

  var DAYS   = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function formatDate(d) {
    return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  // ─── Core Logic ───────────────────────────────────────────────────────────

  function calculateShipDate() {
    var etLocale = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' });
    var etNow    = new Date(etLocale);
    var totalMinutes = etNow.getHours() * 60 + etNow.getMinutes();
    var cutoffMins   = 15 * 60;
    var today = new Date(etNow.getFullYear(), etNow.getMonth(), etNow.getDate());
    var shipDisplayDate;
    if (totalMinutes < cutoffMins) {
      shipDisplayDate = toNextBusinessDay(addDays(today, 1));
    } else {
      var nextShipDay = toNextBusinessDay(addDays(today, 1));
      shipDisplayDate = toNextBusinessDay(addDays(nextShipDay, 1));
    }
    return formatDate(shipDisplayDate);
  }

  // ─── DOM Injection ────────────────────────────────────────────────────────
  // Cached so we only calculate once per page load.

  var cachedDate = null;

  function getDate() {
    if (!cachedDate) cachedDate = calculateShipDate();
    return cachedDate;
  }

  // Fill every ships-by date element currently in the DOM.
  function fillAll() {
    document.querySelectorAll('#flaire-ship-date, .flaire-ships-by__date').forEach(function (el) {
      el.textContent = getDate();
    });
  }

  // Fill any ships-by date element inside a newly added node tree.
  function fillNode(node) {
    if (node.nodeType !== 1) return;
    if (node.id === 'flaire-ship-date' || node.classList.contains('flaire-ships-by__date')) {
      node.textContent = getDate();
    }
    node.querySelectorAll('#flaire-ship-date, .flaire-ships-by__date').forEach(function (el) {
      el.textContent = getDate();
    });
  }

  // Fill immediately if DOM is ready (modal re-injection), or wait for DOMContentLoaded.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillAll);
  } else {
    fillAll();
  }

  // MutationObserver fill — covers the quick-add modal and any other
  // dynamically injected content (e.g. product recommendations, upsell apps).
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(fillNode);
    });
  });

  // Start watching as early as possible so the modal injection is caught.
  (document.body
    ? observer.observe(document.body, { childList: true, subtree: true })
    : document.addEventListener('DOMContentLoaded', function () {
        observer.observe(document.body, { childList: true, subtree: true });
      })
  );

})();
